export default "__VITE_ASSET__8baf247a__"